export default {"src":"/_next/static/media/streetview-color.c1ebebd3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};